import { Tooltip, TooltipColors } from '@quicktools/shared-components/components/core/Tooltip';
import useCopyOnClick from '@quicktools/shared-components/hooks/useCopyOnClick';
import cls from 'classnames';
import { ReactElement, cloneElement, Children, memo } from 'react';

import useStyles from './styles';

function WithEmojiCopy({
  glyph,
  children,
  sendAnalyticsEvent,
}: {
  glyph: string;
  children: ReactElement;
  sendAnalyticsEvent?: () => void;
}) {
  const classes = useStyles();
  const [tooltipVisible, onClick] = useCopyOnClick(glyph, sendAnalyticsEvent);

  return (
    <>
      {Children.map(children, (child) => (
        <div className={classes.tooltipContainer}>
          {cloneElement(child, { onClick })}
          <Tooltip
            withArrow={false}
            className={cls(classes.tooltip, tooltipVisible && classes.tooltipVisible)}
            color={TooltipColors.black}
          >
            Copied
          </Tooltip>
        </div>
      ))}
    </>
  );
}

export default memo(WithEmojiCopy);
